import { combineReducers } from "redux";

import test from "./../test/duck";
import auth from "./../auth/duck";
import registro from "./../registro/duck";
import publicaciones from "./../publicaciones/duck";
import invitacion from "./../invitacion/duck";
import usuarios from "./../usuarios/duck";
import olvidePass from "./../olvidePass/duck";
import marcas from "./../marcas/duck";
import horarios from "./../horarios/duck";
import quiz from "./../quiz/duck";
import servicios from "./../servicios/duck";
import profesionales from "./../profesionales/duck";

import locales from "./../locales/duck";
import changePass from "./../changePass/duck";
import reservas from "./../reservas/duck";
import categorias from "./../categorias/duck";
import productos from "./../productos/duck";
import planes from "./../planes/duck";
import ausencias from "./../ausencias/duck";
import imagenesV3 from "./../imageUploadV3/duck";
import notificacion from "./../notificacion/duck";
import contactos from "./../contactos/duck";


const testReducer = test.duck.reducer;
const loginStandardReducer = auth.duck.reducer;
const loginSocialReducer = auth.duckSocial.reducer;
const registroReducer = registro.duck.reducer;
const usuarioReducer = registro.duckUsuario.reducer;
const getInvitacionReducer = registro.duckInvitacion.reducer;
const getInvitacionesReducer = invitacion.duckGetInvitaciones.reducer;
const invitacionReducer = invitacion.duck.reducer;
const crearAutoInvitacionReducer = registro.duckCrearAutoInvitacion.reducer;
const usuariosReducer = usuarios.duck.reducer;
const getOrganizacionesReducer = invitacion.duckGetOrganizaciones.reducer;
const getOrganizacionByIdReducer = registro.duckOrganizacion.reducer;
const addPublicacionReducer = publicaciones.duck.reducer;
const marcasReducer = publicaciones.duckMarcas.reducer;
const getImagenesReducer = publicaciones.duckGetImagenes.reducer;
const setearImagenPrincipalReducer =
  publicaciones.duckSetearImagenPrincipal.reducer;
const eliminarImagenReducer = publicaciones.duckEliminarImagen.reducer;
const submodelosReducer = publicaciones.duckSubModelos.reducer;
const getPublicacionIncompletaReducer =
  publicaciones.duckGetPublicacionIncompleta.reducer;
const updateProductOptionReducer =
  publicaciones.duckUpdateProductOption.reducer;
const updateProductDetailsReducer =
  publicaciones.duckUpdateProductDetails.reducer;
const publicacionesPorValidarReducer =
  publicaciones.duckPublicacionesPorValidar.reducer;
const submodeloByIdReducer = publicaciones.duckSubmodeloById.reducer;
const publicacionesByUserReducer =
  publicaciones.duckPublicacionesByUser.reducer;
const publicacionesByOrgReducer = publicaciones.duckPublicacionesByOrg.reducer;
const olvidePassReducer = olvidePass.duck.reducer;
const changePassByTokenReducer = olvidePass.duckChangePassByToken.reducer;
const checkResetTokenReducer = olvidePass.duckCheckResetToken.reducer;
const addSubmodeloReducer = marcas.duck.reducer;
const editSubmodeloReducer = marcas.duckEditSubmodelo.reducer;
const cargarHorarioReducer = horarios.duck.reducer;
const opcionesServicioByProfesionalReducer = horarios.duckServicios.reducer;
const getQuizReducer = quiz.getQuizDuck.reducer;
const getQuizzesReducer = quiz.getQuizzesDuck.reducer;
const crearQuizReducer = quiz.crearQuizDuck.reducer;
const editarQuizReducer = quiz.editarQuizDuck.reducer;
const cargarServicioReducer = servicios.duck.reducer;
const editServicioReducer = servicios.duckEditServicio.reducer;
const profesionalesForSelectReducer =
  servicios.duckProfesionalesForSelect.reducer;
const cargarProfesionalReducer = profesionales.duck.reducer;
const editProfesionalReducer = profesionales.duckEditProfesional.reducer;
const eliminarImgProfesionalReducer = profesionales.duckEliminarImgProfesional.reducer;

const cargarLocalReducer = locales.duck.reducer;
const editLocalReducer = locales.duckEditLocal.reducer;
const categoriasForSelectReducer = locales.duckCategoriasForSelect.reducer;
const getLocalesReducer = locales.duckGetLocales.reducer;
const profesionalesByLocalReducer = locales.duckProfesionalesByLocal.reducer;
const localByIdReducer = locales.duckLocalById.reducer;
const serviciosPadreReducer = locales.duckServiciosPadre.reducer;
const serviciosHijosReducer = locales.duckServiciosHijos.reducer;
const serviciosPadreAsOptionsReducer =
  servicios.duckServiciosPadreAsOptions.reducer;
const horariosByLocalReducer = locales.duckHorariosByLocal.reducer;
const horarioByIdReducer = horarios.duckHorarioById.reducer;
const editHorarioReducer = horarios.duckEditHorario.reducer;
const eliminarHorarioReducer = locales.duckEliminarHorario.reducer;
const eliminarImgLocalReducer = locales.duckEliminarImgLocal.reducer;
const eliminarImgBannerLocalReducer = locales.duckEliminarImgBannerLocal.reducer;
const changePassReducer = changePass.changePassDuck.reducer;
const profesionalByIdReducer = profesionales.duckProfesionalById.reducer;
const servicioByIdReducer = servicios.duckServiciosById.reducer;
const eliminarImgServicioReducer = servicios.duckEliminarImgServicio.reducer;
const reservasByLocalReducer = reservas.duck.reducer;
const reservasEnDiaReducer = reservas.reservasEnDiaDuck.reducer;
const categoriasContenidoReducer = categorias.duck.reducer;
const addCategoriasContenidoReducer =
  categorias.duckAddCategoriaContenido.reducer;
const productosByAttrsReducer = productos.duck.reducer;
const addContenidoReducer = productos.duckAddContenido.reducer;
const addQuizOpcionReducer = quiz.addQuizOpcionDuck.reducer;
const editQuizOpcionReducer = quiz.editQuizOpcionDuck.reducer;
const getPlanesReducer = planes.duck.reducer;
const createPlanReducer = planes.createPlanDuck.reducer;
const updatePlanReducer = planes.updatePlanDuck.reducer;
const getPlanByIdReducer = planes.getPlanByIdDuck.reducer;
const createSuscripcionReducer = planes.createSuscripcionDuck.reducer;
const suscripcionesByUsuarioReducer = planes.suscripcionesByUsuarioDuck.reducer;
const getImagenesTemporalesV3Reducer =
  imagenesV3.duckGetImagenesTemporalesV3.reducer;
const eliminacionImgTmpReducer = imagenesV3.duckEliminarImgTmpV3.reducer;
const getAusenciasReducer = ausencias.duck.reducer;
const addAusenciaReducer = ausencias.createAusenciaDuck.reducer;
const deleteAusenciaReducer = ausencias.deleteAusenciaDuck.reducer;
const deleteAusenciasReducer = ausencias.deleteAusenciasDuck.reducer;
const deleteSuscripcionReducer = planes.deleteSuscripcionDuck.reducer;
const cancelarReservaReducer = reservas.cancelarReservaDuck.reducer;

const creacionNotifTemplateReducer = notificacion.crearNotifTemplateDuck.reducer;
const edicionNotifTemplateReducer = notificacion.editarNotifTemplateDuck.reducer;
const getNotifTemplatesReducer = notificacion.getNotifTemplatesDuck.reducer;
const addRecetaReducer = productos.duckAddReceta.reducer;
const deleteContenidoReducer = productos.duckDeleteContenido.reducer;
const deleteRecetaReducer = productos.duckDeleteReceta.reducer;
const eliminarImgQuizOpcionReducer = quiz.duckEliminarImgQuizOpcion.reducer;
const sugerenciasReducer = locales.duckSugerencias.reducer;
const ambientesByLocalReducer = locales.duckAmbientesByLocal.reducer;
const addAmbienteReducer = locales.duckAddAmbiente.reducer;
const updateAmbienteReducer = locales.duckUpdateAmbiente.reducer;
const ambienteByIdReducer = locales.duckAmbienteById.reducer;
const reservasConfirmadasByLocalReducer = reservas.reservasConfirmadasByLocalDuck.reducer;
const primerDiaDisponibleReducer = reservas.primerDiaDisponibleDuck.reducer;
const horariosEntreFechasReducer = reservas.horariosEntreFechasDuck.reducer;
const generarReservasReducer = reservas.generarReservasDuck.reducer;
const segurosByLocalReducer = locales.duckSegurosByLocal.reducer;
const getAmbientesReducer = reservas.getAmbientesDuck.reducer;
const addSeguroReducer = locales.duckAddSeguro.reducer;
const updateSeguroReducer = locales.duckUpdateSeguro.reducer;
const seguroByIdReducer = locales.duckSeguroById.reducer;
const suscripcionesByLocalReducer = planes.suscripcionesByLocalDuck.reducer;
const getReservasObsoletasReducer = reservas.getReservasObsoletasDuck.reducer;
const updateSubcategoriaReducer = servicios.duckUpdateSubcategoria.reducer;
const deleteSubcategoriaReducer = servicios.duckDeleteSubcategoria.reducer;
const deleteServicioReducer = servicios.duckDeleteServicio.reducer;
const simularPendientesReducer = locales.duckSimularPendientes.reducer;
const addContactoReducer = contactos.duck.reducer;
const updateContactoReducer = contactos.duckUpdateContacto.reducer;
const getContactoByIdReducer = contactos.duckContactoById.reducer;
const getContactosReducer = contactos.duckGetContactos.reducer;
const addAsistenciaReducer = contactos.duckAddAsistencia.reducer;
const reservaOptionsReducer = contactos.duckReservaOptions.reducer;
const getContactoByDocumentReducer = contactos.duckContactoByDocument.reducer;
const getAsistenciasByGroupReducer = contactos.duckGetAsistenciasByDategGroup.reducer;
const getAsistenciasByDateReducer = contactos.duckGetAsistenciasByDate.reducer;
const getPromosReducer = locales.duckGetPromos.reducer;
const addPromoReducer = locales.duckAddPromo.reducer;
const reservasALaParReducer = reservas.reservasALaParDuck.reducer;
const terminosReducer = auth.duckTerminos.reducer;
const deletePromoReducer = locales.duckDeletePromo.reducer;
const suscripcionByCiReducer = planes.duckSuscripcionByCi.reducer;
const getLinkConfirmacionReducer = olvidePass.duckLinkConfirmacion.reducer;
const addComentarioInternoReducer = reservas.addComentarioInternoDuck.reducer
const addNroMesaReducer = reservas.addNroMesaDuck.reducer
const ajustarSuscripcionReducer = planes.ajustarSuscripcionDuck.reducer
const eliminarHorariosByLocalReducer = locales.duckEliminarHorariosByLocal.reducer;

const forceLogoutReducer = (state = { forceLogout: false }, action) => {
  switch (action.type) {
    case "FORCE_LOGOUT_NOW":
      return Object.assign({}, state, {
        forceLogout: true,
      });
    default:
      return state;
  }
};

export default combineReducers({
  reservasALaPar: reservasALaParReducer,
  test: testReducer,
  loginStandard: loginStandardReducer,
  loginSocial: loginSocialReducer,
  registro: registroReducer,
  invitacion: invitacionReducer,
  organizaciones: getOrganizacionesReducer,
  addPublicacion: addPublicacionReducer,
  marcas: marcasReducer,
  usuario: usuarioReducer,
  organizacionById: getOrganizacionByIdReducer,
  getInvitacion: getInvitacionReducer,
  imagenes: getImagenesReducer,
  seteoImagenPrincipal: setearImagenPrincipalReducer,
  eliminacionImagenReducer: eliminarImagenReducer,
  submodelos: submodelosReducer,
  publicacionIncompleta: getPublicacionIncompletaReducer,
  updateProductOption: updateProductOptionReducer,
  updateProductDetails: updateProductDetailsReducer,
  publicacionesPorValidar: publicacionesPorValidarReducer,
  publicacionesByUser: publicacionesByUserReducer,
  olvidePass: olvidePassReducer,
  changePassByToken: changePassByTokenReducer,
  checkResetToken: checkResetTokenReducer,
  addSubmodelo: addSubmodeloReducer,
  subodeloById: submodeloByIdReducer,
  editSubmodelo: editSubmodeloReducer,
  getInvitaciones: getInvitacionesReducer,
  usuarios: usuariosReducer,
  publicacionesByOrg: publicacionesByOrgReducer,
  cargarHorario: cargarHorarioReducer,
  opcionesServicioByProfesional: opcionesServicioByProfesionalReducer,
  crearAutoInvitacion: crearAutoInvitacionReducer,
  forceLogoutReducer: forceLogoutReducer,
  quiz: getQuizReducer,
  quizzes: getQuizzesReducer,
  crearQuiz: crearQuizReducer,
  editarQuiz: editarQuizReducer,
  cargarServicio: cargarServicioReducer,
  editServicio: editServicioReducer,
  profesionalesForSelect: profesionalesForSelectReducer,
  cargarProfesional: cargarProfesionalReducer,
  editProfesional: editProfesionalReducer,
  cargarLocal: cargarLocalReducer,
  editLocal: editLocalReducer,
  categoriasForSelect: categoriasForSelectReducer,
  getLocales: getLocalesReducer,
  profesionalesByLocal: profesionalesByLocalReducer,
  localById: localByIdReducer,
  serviciosPadre: serviciosPadreReducer,
  serviciosHijos: serviciosHijosReducer,
  serviciosPadreAsOptions: serviciosPadreAsOptionsReducer,
  horariosByLocal: horariosByLocalReducer,
  horarioById: horarioByIdReducer,
  editHorario: editHorarioReducer,
  eliminarHorario: eliminarHorarioReducer,
  changePass: changePassReducer,
  profesionalById: profesionalByIdReducer,
  servicioById: servicioByIdReducer,
  eliminacionImgServicio: eliminarImgServicioReducer,
  eliminacionImgProfesional: eliminarImgProfesionalReducer,
  reservasByLocal: reservasByLocalReducer,
  categoriasContenido: categoriasContenidoReducer,
  addCategoriasContenido: addCategoriasContenidoReducer,
  productosByAttrs: productosByAttrsReducer,
  addContenido: addContenidoReducer,
  addQuizOpcion: addQuizOpcionReducer,
  editQuizOpcion: editQuizOpcionReducer,
  getPlanes: getPlanesReducer,
  createPlan: createPlanReducer,
  updatePlan: updatePlanReducer,
  getPlanById: getPlanByIdReducer,
  createSuscripcion: createSuscripcionReducer,
  suscripcionesByUsuario: suscripcionesByUsuarioReducer,
  imagenesTemporalesV3: getImagenesTemporalesV3Reducer,
  eliminacionImgTmp: eliminacionImgTmpReducer,
  getAusencias: getAusenciasReducer,
  addAusencia: addAusenciaReducer,
  deleteAusencia: deleteAusenciaReducer,
  deleteSuscripcion: deleteSuscripcionReducer,
  cancelarReserva: cancelarReservaReducer,
  creacionNotifTemplate: creacionNotifTemplateReducer,
  edicionNotifTemplate: edicionNotifTemplateReducer,
  notifTemplates: getNotifTemplatesReducer,
  addReceta: addRecetaReducer,
  deleteContenido: deleteContenidoReducer,
  deleteReceta: deleteRecetaReducer,
  eliminacionImgQuizOpcion: eliminarImgQuizOpcionReducer,
  eliminacionImgLocal: eliminarImgLocalReducer,
  eliminacionImgBannerLocal: eliminarImgBannerLocalReducer,
  sugerencias: sugerenciasReducer,
  ambientesByLocal: ambientesByLocalReducer,
  addAmbiente: addAmbienteReducer,
  updateAmbiente: updateAmbienteReducer,
  ambienteById: ambienteByIdReducer,
  reservasConfirmadasByLocal: reservasConfirmadasByLocalReducer,
  primerDiaDisponible: primerDiaDisponibleReducer,
  horariosEntreFechas: horariosEntreFechasReducer,
  generarReservas: generarReservasReducer,
  getAmbientes: getAmbientesReducer,
  segurosByLocal: segurosByLocalReducer,
  addSeguro: addSeguroReducer,
  updateSeguro: updateSeguroReducer,
  seguroById: seguroByIdReducer,
  suscripcionesByLocal: suscripcionesByLocalReducer,
  getReservasObsoletas: getReservasObsoletasReducer,
  updateSubcategoria: updateSubcategoriaReducer,
  deleteSubcategoria: deleteSubcategoriaReducer,
  deleteServicio: deleteServicioReducer,
  simularPendientes: simularPendientesReducer,
  addContacto: addContactoReducer,
  updateContacto: updateContactoReducer,
  getContactoById: getContactoByIdReducer,
  getContactos: getContactosReducer,
  addAsistencia: addAsistenciaReducer,
  reservaOptions: reservaOptionsReducer,
  getContactoByDocument: getContactoByDocumentReducer,
  getAsistenciasByGroup: getAsistenciasByGroupReducer,
  getAsistenciasByDate: getAsistenciasByDateReducer,
  getPromos: getPromosReducer,
  addPromo: addPromoReducer,
  terminos: terminosReducer,
  deletePromo: deletePromoReducer,
  suscripcionByCi: suscripcionByCiReducer,
  getLinkConfirmacion: getLinkConfirmacionReducer,
  deleteAusencias: deleteAusenciasReducer,
  addComentarioInterno: addComentarioInternoReducer,
  addNroMesa: addNroMesaReducer,
  ajustarSuscripcion: ajustarSuscripcionReducer,
  eliminarHorariosByLocal: eliminarHorariosByLocalReducer,
  reservasEnDia: reservasEnDiaReducer
});
